import { isSameDay } from 'date-fns'
import * as Effects from 'redux-saga/effects'
import {
  addSelectedColumns,
  deleteSelectedColumns,
  IAddSelectedColumns,
  IDeleteSelectedColumns,
  ISelectCalendarColumn,
  replaceSelectedColumns,
} from '../../actions/bookingCalendar/calendar/selectColumn'
import { callFetch } from '../../actions/fetch'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import {
  addSelectedColumn,
  deleteSelectedColumn,
  fetchSelectedColumns,
} from '../../models/Calendar'
import { CalendarActions } from '../../reducers/bookingCalendar/actionNames'
import { getSelectedColumns } from '../../reducers/bookingCalendar/selectors/selectedColumns'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* fetchColumnsFromApi(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchSelectedColumns)
    const [{ calendarId, service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchSelectedColumns),
      ),
    ])
    if (!calendarId) {
      yield Effects.delay(500)
      yield* fetchColumnsFromApi(action)
      return
    }

    let columns: Date[] = []

    if (action.columns) {
      columns = action.columns
    } else {
      columns = yield Effects.call(service, calendarId)
    }

    yield Effects.put(replaceSelectedColumns(columns))
  } catch {
    yield Effects.put(
      fireToastError(i18n.t('BBO_927_toast_cant_download_selected_days')),
    )
  }
}

function* selectColumn(action: ISelectCalendarColumn) {
  const selectedColumns: Date[] = yield Effects.select(getSelectedColumns)
  const lookingFor = selectedColumns.find(column =>
    isSameDay(column, action.index),
  )

  if (lookingFor) {
    yield Effects.put(
      replaceSelectedColumns(
        selectedColumns.filter(day => !isSameDay(day, lookingFor)),
      ),
    )
    yield Effects.put(deleteSelectedColumns(lookingFor))
  } else {
    yield Effects.put(
      replaceSelectedColumns([...selectedColumns, action.index]),
    )
    yield Effects.put(addSelectedColumns(action.index))
  }
}

function* deleteColumns(action: IDeleteSelectedColumns) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteSelectedColumn)
    const [{ calendarId, service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, deleteSelectedColumn),
      ),
    ])
    yield Effects.call(service, calendarId, action.column)
    yield Effects.put({ type: 'Update selected columns notify' })
  } catch (e) {
    yield Effects.put(
      fireToastError(i18n.t('BBO_927_toast_cant_save_salected_days')),
    )
  }
}

function* addColumns(action: IAddSelectedColumns) {
  try {
    const actionNames = fetchActionsName(ActionNames.AddSelectedColumn)
    const [{ calendarId, service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, addSelectedColumn),
      ),
    ])
    yield Effects.call(service, calendarId, action.column)

    yield Effects.put({ type: 'Update selected columns notify' })
  } catch (e) {
    yield Effects.put(
      fireToastError(i18n.t('BBO_927_toast_cant_save_salected_days')),
    )
  }
}

function* notifyUser() {
  yield Effects.put(
    fireToastSuccess(
      i18n.t('BBO_927_toast_selected_days_updated'),
      5000,
      'Main',
      'columnsUpdated',
    ),
  )
}

export default function*() {
  yield Effects.debounce(
    1000,
    CalendarActions.FetchSelectedColumns,
    fetchColumnsFromApi,
  )
  yield Effects.takeEvery(CalendarActions.AddSelectedColumns, addColumns)
  yield Effects.takeEvery(CalendarActions.DeleteSelectedColumns, deleteColumns)
  yield Effects.takeEvery(CalendarActions.SelectColumn, selectColumn)
  yield Effects.debounce(2000, 'Update selected columns notify', notifyUser)
}
